// Limites de renda - Lei 7.888/2021 Art. 145 (Guarulhos)
export var LIMITE_6SM = 9726;
export var LIMITE_10SM = 16210;
export var TOTAL_LOTES = 601;

// Metas da lei (percentuais)
export var META_ATE_6SM = 50;
export var META_6_A_10SM = 30;
export var META_LIVRE = 20;

export var ITENS_POR_PAGINA = 20;

export var FAIXAS = {
  ATE_6SM: {
    key: 'ate6sm',
    label: 'Até 6 SM',
    cor: '#28a745',
    corClara: 'rgba(40, 167, 69, 0.2)',
  },
  DE_6_A_10SM: {
    key: 'de6a10sm',
    label: '6 a 10 SM',
    cor: '#ffc107',
    corClara: 'rgba(255, 193, 7, 0.2)',
  },
  LIVRE: {
    key: 'livre',
    label: 'Livre',
    cor: '#17a2b8',
    corClara: 'rgba(23, 162, 184, 0.2)',
  },
  NAO_INFORMADA: {
    key: 'naoInformada',
    label: 'Renda N/I',
    cor: '#dc3545',
    corClara: 'rgba(220, 53, 69, 0.2)',
  },
};

export var TABS = [
  { key: 'todos', label: 'Todos' },
  { key: 'ate6sm', label: 'Até 6 SM' },
  { key: 'de6a10sm', label: '6 a 10 SM' },
  { key: 'livre', label: 'Livre' },
  { key: 'naoInformada', label: 'Renda N/I' },
];

export var INTERESSE_SOCIAL_OPTIONS = [
  { value: '', label: 'Todos' },
  { value: 'true', label: 'Sim' },
  { value: 'false', label: 'Não' },
];

export var TIPO_RENDA_OPTIONS = [
  { value: '', label: 'Todos' },
  { value: 'SomenteFamiliar', label: 'Somente Familiar' },
  { value: 'SomentePessoal', label: 'Somente Pessoal' },
  { value: 'Ambos', label: 'Ambos' },
  { value: 'NaoPreenchido', label: 'Não Preenchido' },
];

export var DOCUMENTACAO_OPTIONS = [
  { value: '', label: 'Todos' },
  { value: 'Completa', label: 'Completa' },
  { value: 'Incompleta', label: 'Incompleta' },
];

export var TIPO_VENDA_OPTIONS = [
  { value: '', label: 'Todas' },
  { value: 'SomenteVendas', label: 'Somente com Vendas' },
  { value: 'SomenteSemVendas', label: 'Somente sem Vendas' },
];
